// zh_cn.js繁体文件
export default {
	message: {
		language: '語言',
		plogin: '請先登錄！',
		login: '登錄',
		login1: '立即登錄',
		logintips: '登錄後體驗更多服務',
		register: '註冊',
		register1: '立即註冊',
		loginout: '退出',
		join: '加入',
		days: '天',
		lastip: '上次登錄IP',
		account: '賬號',
		game: '遊戲',
		video: '視頻',
		collect: '收藏',
		Favorite: '已收藏',
		collect1: '收藏夾',
		share: '分享',
		sharelive: '分享直播',
		Cache: '緩存',
		download: '下載',
		wallet: '錢包',
		recharge: '充值',
		withdraw: '提現',
		noble: '貴族',
		record: '記錄',
		RechargeTime: '充值時間',
		WithdrawalTime: '提現時間',
		RechargeRecord: '充值記錄',
		WithdrawalRecords: '提現記錄',
		TransactionRecords: '交易記錄',
		business: '商務',
		message: '消息',
		activity: '優惠',
		setting: '設置',
		help: '幫助',
		version: '版本',
		loggingout: '退出登錄',
		remember: '記住密碼',
		forget: '忘記密碼',
		noaccount: '沒有賬號',
		returnhome: '返回首頁',
		bottomtips: '本集團受菲律賓PAGCOR 及 英國馬恩島博彩協會監管合法運營',
		days21: '已滿21周歲，並且閱讀及同意',
		rules: '規則與條款',
		hadaccount: '已有賬號',
		gonggao: '公告',
		system: '系统',
		home: '首頁',
		kefu: '客服',
		kefuCenter: '客服中心',
		mykf1desc: '請下載以下專屬APP添加ID與我聯系',
		mykf2desc: '下載地址',
		mykf3desc1: '在線客服',
		mykf3desc2: '點擊開始在線聊天',
		mykf3desc3: '處理充值不到賬，提現以及遊戲問題',
		my: '我的',
		close: '關閉',
		zuixin: '最新',
		yhdetail: '優惠詳情',
		mywallet: '我的錢包',
		zichan: '資產',
		yuan: '元',
		zxwallet: '中心錢包',
		ptwallet: '平台錢包',
		transfer: '轉賬',
		LimitTransfer: '額度轉賬',
		cards: '卡包管理',
		gamebalance: '遊戲餘額',
		onerecycle: '一鍵回收',
		Recovery: '回收金額',
		Recycling: '回收中',
		wei: '維',
		loading: '加載中',
		refreshing: '刷新中',
		refreshend: '刷新成功',
		success: '操作成功',
		czamount: '充值金額',
		limit: '限額',
		saccount: '選擇賬戶',
		skbank: '收款銀行',
		skname: '收款姓名',
		copy: '複製',
		skcard: '收款卡號',
		submit: '提交',
		Confirmsubmit: '確認提交',
		nextstep: '下一步',
		customerservice: '人工客服',
		pleasecontact: '如果您有任何問題，請聯繫',
		copysuccess: '已成功複製到粘貼板',
		copyfail: '複製失敗',
		firstmoney: '請先輸入充值金額',
		rechargelowtips: '充值金額不能小於最低限額',
		rechargeuptips: '充值金額不能大於最高限額',
		firstaccount: '請先選擇賬戶',
		selwallet: '選擇錢包',
		firstoutwallet: '請先選擇轉出錢包',
		retract: '收起',
		expend: '展開',
		mzmodel: '免轉模式',
		mzmodeltips: '開啟後餘額自動轉入遊戲場館',
		seloutwallet: '選擇轉出錢包',
		selinwallet: '選擇轉入錢包',
		transfertips: '場館錢包之間不可以互轉',
		maxamount: '最大金額',
		codings: '打碼量',
		washingAmount: '洗碼量',
		withamount: '提現金額',
		banks: '銀行卡',
		withzhtips: '請先綁定提現賬戶',
		withmoneytips: '請先輸入提現金額',
		add: '添加',
		antoken1: '全球领先的虚拟币在线钱包，充值提现自动实时到账，转账交易更快捷，更安全',
		antoken2: 'AnToken個人錢包APP下載：點擊直接訪問網址',
		antoken3: 'https://antoken.pro',
		cardtips: '溫馨提示：每個賬戶只能綁定5張，如若修改請刪除後重新添加！',
		walletaddress: '錢包地址',
		walletaddressdesc: '請填寫ec開頭 34位英數組合的K豆地址',
		USDTaddress: 'USDT地址',
		unbindingtips: '確定要解綁嗎？',
		paypass: '支付密碼',
		cardprotocol: '錢包協議',
		cardaddress: '錢包地址',
		Cardholder: '持卡人',
		bankcard: '銀行卡號',
		bankname: '開戶銀行',
		banknamedesc: '請選擇開戶銀行',
		bankaddress: '開戶地址',
		bankaddressdesc: '請選擇開戶地址',
		bankother: '開戶支行',
		firstpaypass: '請先輸入支付密碼',
		bindtips: '請妥善填寫信息，綁定後不可修改',
		Paymentcode: '收款碼',
		platname: '騰達娛樂',
		records: '充提記錄',
		gameRecord: '遊戲記錄',
		betrecord: '遊戲註單',
		betDetail: '下註詳情',
		accountsetting: '賬戶設置',
		messages: '我的消息',
		returnrecord: '返水記錄',
		transferrecord: '轉賬記錄',
		activityrecord: '活動申請記錄',
		applyfor: '申請',
		welfare: '紅包',
		query: '查詢',
		Time: '時間',
		To: '至',
		dllogin: '代理登錄',
		outsuccess: '退出成功',
		today: '今日',
		days7: '進7日',
		days14: '進14日',
		days30: '進30日',
		cunkuan: '存款',
		qukuan: '取款',
		ordersn: '訂單號',
		money: '金額',
		state: '狀態',
		nomore: '沒有更多了',
		More: '更多',
		SeeMore: '查看更多',
		Detail: '查看詳情',
		Changebatch: '換一批',
		Lovely: '猜你喜歡',
		selplatform: '選擇平台',
		betamount: '投注金額',
		betgame: '遊戲',
		betresult: '投注結果',
		perfect1: '完善賬戶信息，更安全',
		perfect2: '完善個人資料',
		perfect3: '資料更完整，我們的服務更加周到',
		perfect4: '去完善',
		binding: '綁定',
		AddBinding: '新增綁定',
		carding1: '卡片管理',
		carding2: '如需提現，請綁定銀行卡或虛擬幣地址',
		logpassword1: '登錄密碼',
		logpassword2: '定期修改登錄密碼，有利賬號安全',
		paypassword1: '支付密碼',
		paypassword2: '定期修改支付密碼，有利賬號安全',
		oldloginpass: '原登錄密碼',
		newloginpass: '新登錄密碼',
		oldloginpassdesc: '請輸入原登錄密碼',
		newloginpassdesc: '請輸入新登錄密碼',
		confirmpass: '確認密碼',
		confirmpassdesc: '請輸入確認密碼',
		oldpaypass: '原支付密碼',
		newpaypass: '新支付密碼',
		oldpaypassdesc: '請輸入原支付密碼',
		newpaypassdesc: '請輸入新支付密碼',
		personalinformation: '編輯資料',
		edit: '編輯',
		SelectAll: '全選',
		Delete: '刪除',
		avatar: '上傳頭像',
		username: '用戶名',
		userID: '用戶ID',
		userIDdesc: '請輸入用戶ID',
		username1: '用戶名',
		realname: '真實姓名',
		nickname: '昵稱',
		realname2: '真實姓名',
		realname1: '姓名或昵稱',
		realname1desc: '請輸入姓名或昵稱',
		realnamedesc: '請輸入姓名',
		nicknamedesc: '請輸入昵稱',
		sex: '性別',
		birthday: '生日',
		birthdaydesc: '請選擇生日',
		email: '郵箱',
		phone: '手機號',
		nationality: '國籍',
		nationalitydesc: '請輸入國籍',
		education: '學歷',
		educationdesc: '請輸入學歷',
		AnnualSalary: '年薪',
		AnnualSalarydesc: '請輸入年薪',
		work: '工作',
		workdesc: '請輸入工作',
		RegistrationTime: '註冊時間',
		LastLogin: '最後登錄',
		operate: '操作',
		mail: '站內信',
		allplat: '全平台',
		upgrade: '升级',
		draw: '領取',
		Received: '已領取',
		totaldraw: '累計領取',
		undraw: '待領取',
		transin: '轉入',
		transout: '轉出',
		transtype: '選擇交易類型',
		walfareinfo: '紅包情況',
		help1: 'Hi,尊敬的會員用戶',
		help2: '歡飲來到幫助中心',
		help3: '若相關問題仍未解決，可咨詢在線客服',
		ungot: '未達標',
		got: '已達標',
		totalrecharge: '累計充值',
		totalwater: '累計流水',
		waterratio: '返水比例',
		jinji: '晉級',
		lijin: '禮金',
		level: '等級',
		hot: '熱門',
		live: '真人',
		slot: '電子',
		chess: '棋牌',
		sports: '體育',
		lottery: '彩票',
		fishing: '捕魚',
		actrules: '活動規則',
		accountlogin: '賬號密碼登錄',
		mobilelogin: '手機快捷登錄',
		password: '密碼',
		newpassword: '新密碼',
		pleaseaccount: '請輸入賬號名',
		passtips: '密碼長度6-15個字符，必須由字母幾數字組成！',
		pleasepass: '請輸入密碼',
		pleasetwcode: '情輸入圖文驗證碼',
		country: '國家/手機號',
		pleasemobile: '請輸入手機號',
		yzm: '驗證碼',
		pleaseyzm: '請輸入手機驗證碼',
		sendcode: '發送驗證碼',
		currency: '幣種',
		usernametips: '請輸入4-16位字符，含英數',
		currencytips: '請輸入幣種',
		againpass: '再次輸入以上密碼',
		ckmoney: '存款金額',
		ckdate: '存款日期',
		redmoney: '紅包金額',
		activitycenter: '活動',
		lucrative: '推廣',
		MemberManagement: '會員管理',
		CommissionSettlement: '傭金結算',
		CommissionRecords: '傭金記錄',
		FriendTransfer: '好友轉賬',
		nightMode: '深夜模式',
		Mobileauth: '手機認證',
		Certified: '已認證',
		nodata: '沒有數據啦',
		Sportslive: '體育直播',
		MemberID: '會員ID',
		MemberIDdesc: '請輸入會員ID',
		friendID: '好友ID',
		friendIDdesc: '請輸入好友ID或手機號碼',
		findMember: '找回會員',
		Platformfees: '平臺費用',
		PromotionalMaterials: '推廣素材',
		copylink: '復製鏈接地址',
		SaveQRcode: '保存二維碼',
		interest: '關註',
		eliminate: '剔除',
		Recommend: '推薦',
		new: '新',
		searchfor: '搜索',
		searchfordesc: '請輸入搜索內容',
		find: '找到',
		results: '結果',
		Cashier: '收銀臺',
		skip: '跳過',
		Enterimmediately: '馬上進入',
		APPlock: 'APP應用鎖',
		actTime: '活動時間',
		confirm: '確定',
		platformtype: '平臺類型',
		orderState: '訂單狀態',
		gameName: '遊戲名稱',
		gameNamedesc: '請輸入遊戲名稱',
		bettime: '下註時間',
		validamount: '下註金額',
		winloss: '中獎金額',
		betnum: '遊戲單號',
		normal: '正常',
		abnormal: '非正常',
		betTotal: '下註總金額',
		winTotal: '中獎總金額',
		Orderamount: '下單金額',
		Orderbet: '下單註量',
		male: "男",
		female: "女",
		electron: "電子遊戲",
		Dailyvideo: "每日視頻推薦",
		Choicevideo: "精選推薦",
		videoList1: "每日最新更新",
		videoList2: "人氣最佳視頻",
		videoList3: "免費視頻",//短視頻
		mydata1: "影視VIP剩余天數",
		mydata2: "待領取返水金額",
		waterAmount: "返水金額",
		waterDate: "返水日期",
		noblet1: '升級VIP立即全站高清無限看',
		noblet2: '先到先得快來搶購吧',
		noblet3: '無限看，贈送',
		noblet4: '查看購買VIP記錄',
		noblet5: '點擊此處',
		order1: '次',
		Transamount: '可轉出金額',
		Dailylimit: '單日限額',
		vipIDdesc: '請輸入會員ID或手機號碼',
		Transferaccount: '轉入賬號',
		Transfermoney: '轉入金額',
		Transfert1: '註：參與優惠活動，提款限製將無法到賬',
		Transfert2: '註：提交成功後，系統將在10分鐘內到賬，如若未到賬請聯系客服',
		amount: '金額',
		receiptTime: '到賬時間',
		Transferfriends: '轉出好友',
		Transferringfriends: '轉入好友',
		Descriptive: '描述信息',
		exchangerate: '實時匯率',
		Accountbalance: '賬戶余額',
		withdrawal: '提現所需打碼量',
		commission: '手續費',
		Exchangerate: '匯率計算',
		illustrate: '說明',
		withdrawtilt1: '最低提現100起，如未到賬請及時聯系在線客服。',
		withdrawtilt2: '提款銀行卡必須是本人銀行卡，否則無法到賬。',
		tips: '提示',
		findvipt1: '通過此功能可以找回沒有綁定成功的下級會員。',
		findvipt2: '限綁定註冊時間3天內的下級會員。',
		Totalplatformcost: '平臺總費用',
		Winlamount: '輸贏金額',
		PlatformRate: '平臺費率',
		totalExpenses: '費用總額',
		commission1: '當前傭金比例',
		commission2: '傭金比例',
		Mycommission: '我的傭金',
		totalRecharge: '充值總額',
		totalWithdraw: '提現總額',
		totalPeople: '會員人數',
		activePeople: '活躍會員',
		addPeople: '本月新增',
		SettlementDate: '結算日期',
		DayMonth: '日 / 月',
		ImmeSettle: '立即結算',
		Formula: '計算公式',
		SettleMoney: '已領取傭金金額',
		Date: '日期',
		authname: '認證姓名',
		authnamedesc: '請填寫匯款人姓名',
		hashelp: '如需幫助',
		contact: '聯系客服',
		Agreement: '協議/幣種',
		ckNumber: '存款個數',
		cbaddress: '充幣地址',
		notes: '備註',
		Scancoins: '掃碼充幣',
		content: '內容',
		ckdesc: '請輸入存款詳情',
		zfAccount: '支付賬戶',
		zfbank: '支付銀行',
		banktype: '充值類型',
		banktypedesc: '請選擇充值類型',
		zzzh: '轉出賬戶',
		zjzh: '轉入賬戶',
		whole: '全部',
		zzmoney: '轉賬金額',
		zhtime: '轉賬時間',
		zzpt: '轉賬平臺',
		Paymentmethod: '支付方式',
		behalf: '好友代付',
		saccountdesc: '請選擇收款賬戶',
		cztips: '請轉賬金額到以上賬戶再提交表單，工作人員將第一時間為您辦理。',
		currency1: '貨幣',
		exchangeRate1: '匯率',
		Rebate: '返利',
		Receive1: '充值到賬',
		PaymentVoucher: '上傳支付憑證',
		DepositTime: '存款時間',
		DepositTimedesc: '請選擇存款時間',
		BlockchainID: '區塊鏈ID',
		BlockchainIDdesc: '請輸入區塊鏈ID',
		tradeID: '交易ID後六位',
		tradeIDdesc: '請輸入交易ID後六位',
		withdraw1: '提現到賬',
		gamenoIndesc: '遊戲維護中，請稍後再試~',
		cznamedesc1: '首次在線充值，必須綁定真實姓名。',
		cznamedesc2: '請確保此姓名與存款人姓名壹致，否則無法到賬。',
		cznamedesc3: '提交保存後，不可更改，請仔細填寫。',
		txnamedesc1:'首次綁定信息，必須綁定真實姓名。',
		txnamedesc2:'請確保此姓名與提款人姓名壹致，否則無法到賬。',
		txnamedesc3:'提交保存後，不可更改，請仔細填寫。',
		modify: '修改',
		inviteId:'邀請碼',
		findpaypass:'找回支付密碼',
		Movies:'影視',
		rakeback:'返水',
		rescue:'救援',
		RedeemCode:'兌換碼',
		dhTitle: '我的兌換記錄',
		dhtxt: '兌換',
		dhtxtbtn: '立即兌換',
		dhtxtdesc: '輸入兌換碼',
		dhmoney: '兌換金額',
		dhlsbs: '流水倍數',
		lqtime: '領取時間',
		free:'免費',
		zznamedesc1:'請務必填寫轉賬人真實姓名，否則無法自動到賬。',
		zznamedesc2:'若10分鐘內，充值金額未到賬，請聯系在線客服。',
		tgrs:'當前推廣人數',
		tglink:'推廣鏈接',
		tgyqewm:'邀請二維碼',
		wxts:'溫馨提示',
		tgtips1:'申請獨立域名，請聯系代理專員.',
		tgtips2:'若您是站長, 需要廣告素材,請聯系客服.',
		tgtips3:'邀請好友註冊,只需讓您的好友在註冊時填寫邀請碼即可.',
		mycenter: '個人中心',
		myInfo: '個人信息',
		mylucrative: '我的推廣',
		Security: '賬戶安全',
		timeframe: '時間範圍',
		starttime: '開始時間',
		endtime: '結束時間',
		Keysdesc: "請選擇國家",
		Keysdesc1: "請選擇區碼",
		rule1: '已滿21周歲，並且閱讀及同意',
		rule2: '【規則與條款】',
		autotrans:'自動免轉',
		autotranstips:'遊戲時，余額將自動轉入對應遊戲賬戶',
		handtrans:'手動轉賬',
		handtranstips:'如需手動轉賬，請關閉【自動免轉】',
		jytype:'交易類型',
		wechat:'微信',
		Alipay:'支付寶',
		yjed:'傭金額度',
		yjsed:'已結算的額度',
	},
	footer: {
		fkfs: '付款方式',
		partners: '合夥人',
		followUs: '關註我們',
		regauth: '監管機構',
		pagcor: 'PAGCOR',
		legalage: '法定年齡',
		cs: '客服',
		telegram: '飛機',
		network: '網絡',
		dark: '夜間',
		byday: '白天',
		affiliate: '關聯',
		TOP: '頂部',
		chat: '聊天',
	},
	home: {
		hotgametit: "熱門遊戲",
		activitydesc1: "騰達超級禮遇",
		activitydesc2: "呼朋喚友彩金齊齊賺",
		new: "最新",
		Chesscardsdesc1: "國際棋牌",
		Chesscardsdesc2: "逼真的遊戲體驗，",
		Chesscardsdesc3: "逼真的人工智能，",
		Chesscardsdesc4: "多種模式和新的遊戲方式",
		Chesscardsdesc5: "高端棋牌遊戲，超級火爆平臺..",
		lotterydesc1: "彩票",
		lotterydesc2: "與經典和創新的彩票遊戲，",
		lotterydesc3: "這將增加欲望的遊戲過程",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: "我們秉持著「服務至上」的理念，致力於為廣大的會員玩家們提供",
		onsitedesc3: "最豐富的線上博彩遊戲及多元化高值量的服務系統",
		placeholderdesc: "請輸入遊戲名稱",
		gogamebtn: "進入遊戲",
		swgamebtn: "試玩遊戲",
		swbtn: "試玩",
		egamesdesc1: "掌上遊戲軟件",
		egamesdesc2: "全球領先的電子遊戲供應商，",
		egamesdesc3: "主要從事線下和線上電子遊戲開發。",
		egamesdesc4: "擁有亞洲最大的娛樂城市",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "頂級娛樂平臺",
		livedesc4: "龍虎、炸金花、色碟、番攤等玩法桌臺任君挑選，",
		livedesc5: "讓您擁有身臨其境的奢華體驗！",
		sportdesc1:"體育",
		sportdesc2:"大多數類型的投註，最強的投註體驗，",
		sportdesc3:"支持提前套現，",
		sportdesc4:"收集大米快一步，想想你的想法，",
		sportdesc5:"投票給你喜歡的人。",
		fishdesc1:"捕魚",
		fishdesc2:"瘋狂釣魚！超高爆炸",
		fishdesc3:"速率，巨大的寶藏等著你去抓！",
		tiptitle: '重要提醒',
		tipclose: '關閉',
		tipflag: '今日不提醒',
		testdesc1: "最新官方網址",
		testdesc2: "溫馨提示: 最小MS數值的網址打開速度就越快！",
		LinkTimeout: "鏈接超時",
		GoImmediately: "立即前往",
		Recheck: "重新檢查訪問速度",
		Enter:'進入',
	},
	help: {
		title0: '關於我們',
		title1: '常見問題',
		title2: '隱私政策',
		title3: '免責聲明',
		title4: '聯系我們',
		title5: '代理加盟',
		title6: '博彩責任',
		title7: '商務合作',
		service: '在線客服',
		servicedesc: '快速，便捷，及時提供溝通',
	},
	download: {
		scantxt: '掃描二維碼下載APP',
		downtext: "APP下載",
		downdesc: "立即開立TDBET賬戶並享受最優惠的獎金！",
		version: "版本",
		ScanCodedown: "掃碼下載APP",
		BeCurrent: "通用",
		H5org: "H5頁面訪問",
	},
	vip: {
		viptitle: "騰達VIP",
		viptitle1: "巔峰盛典",
		viptitle2: "榮耀起航",
		viptitle3: "加入騰達VIP 享頂級至尊服務",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "累計充值",
		totalBet: "累計流水",
		vipBLdesc: "VIP返水比例",
		vipgradetitle: "VIP等級",
		vipgrade1: "真人返水",
		vipgrade2: "電子返水",
		vipgrade3: "棋牌返水",
		vipgrade4: "體育返水",
		vipgrade5: "彩票返水",
		vipgrade6: "電競返水",
		ActivityRules: "活動規則",
		Rulestext1: "晉升標準",
		Rulesdesc1: "會員的累計存款以及累計流水達到相應級別的要求，即可在次日24點前晉級相應VIP等級。",
		Rulestext2: "晉升順序",
		Rulesdesc2: "VIP等級達到相應的要求可每天晉升一級，但VIP等級不可越級晉升。",
		Rulestext3: "保級要求",
		Rulesdesc3: "會員在達到某VIP等級後，90天內投註需要完成保級流水要求。如果在此期間完成晉升，保級要求重新按照當前等級計算。",
		Rulestext4: "降級標準",
		Rulesdesc4: "如果會員在一個季度（90天計算）內沒有完成相應的保級要求流水，系統會自動降級一個等級，相應的返水及其它優惠也會隨之調整至降級後的等級。",
		Rulestext5: "升級禮金",
		Rulesdesc5: "升級禮金在會員達到該會員級別後系統自動派發，每個級別的升級禮金每位會員僅能獲得1次（升級禮金1倍流水即可提款）。",
		Rulestext6: "生日禮金",
		Rulesdesc6: "會員在註冊三個月內過生日，今年將不能領取生日禮金。另註冊時間大於三個月的會員需在生日當天的VIP頁面進行自助領取，每年可領取一次。（生日禮金1倍流水即可提款）。",
		Rulestext7: "每月紅包",
		Rulesdesc7: "會員在上個月有過至少1次的存款成功記錄，即可在次月1號和16號分別前往VIP頁面領取當天相應等級的每月紅包彩金的1/2（紅包禮金1倍流水即可提款）",
		Rulestext8: "騰達娛樂 娛樂保留對活動的修改，停止及最終解釋權。",
		Rulesdesc8: "備註：以上為各場館最高返水，具體返水金額請以實際遊戲為準，每日返水將在次日的15:00 - 16:00陸續進行發放。",
	
	},
}


// WEBPACK FOOTER //
// ./src/lang/zh_tw.js